import Auth from "@/components/Auth.vue";
import MailDetails from "@/components/MailDetails.vue";
import Main from "@/components/Main.vue";

import store from "@/store";

import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Main",
    component: Main,
    meta: { requiresAuth: true },
  },
  {
    path: "/mail/:id",
    name: "MailDetail",
    component: MailDetails,
    meta: { requiresAuth: true },
  },
  {
    path: "/auth/:provider?",
    name: "Auth",
    component: Auth,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth && store.state.isInit) {
    // Предполагается, что в Vuex есть состояние или геттер для проверки авторизации
    const isAuthenticated = store.state.auth; // или store.getters.isAuth

    if (isAuthenticated) {
      // Пользователь авторизован, переходим
      next();
    } else {
      // Пользователь не авторизован, перенаправляем на страницу авторизации
      next({ name: "Auth" });
    }
  } else {
    // Маршрут не требует авторизации
    next();
  }
});
export default router;
